import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import homeLogo from "../../Assets/home-main.svg";
// import Particle from "../Particle";
// import Home2 from "./Home2";
import Type from "./Type";
import About from '../About/About';
import Projects from '../Projects/Projects';
import BackToTopButton from '../ExtraFeatures/BackToTopButton';

// import EmailDisplay from '../ExtraFeatures/EmailDisplay';
import { FaLinkedinIn } from "react-icons/fa";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import ChatbotButton from "../ExtraFeatures/ChatbotButton";

export default function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        {/* <Particle /> */}
        <Container className="home-content">
          {/* <Row> */}
            <Col md={5} className="home-header">
              <h1 style={{ paddingTop: 50 }} className="heading">Hello Everyone{" "}
                {/* <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span> */}
              </h1>

              <h1 className="heading-name"> My name is
                <strong className="main-name"> ASIF ALAM</strong>
              </h1>
              <br/>
              <div style={{ padding: 43 }}>
                And I'M a <Type />
                <br/>
              </div>
            </Col>

            {/* <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col> */}
          {/* </Row> */}
        </Container>
      </Container>
      <ChatbotButton/>
      <BackToTopButton />
      {/* <Home2 /> */}
      {/* <EmailDisplay /> */}
      <hr/>
      <hr/>
      <About />
      <hr/>
      <Projects />
      <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/code-asif"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/AsifAla50918674"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/asif-alam-ba19531b0/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/aryant_alam/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
    </section>
  );
}